var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.52C0 6.60225 6.98672 0 16 0C25.0133 0 32 6.60225 32 15.52C32 24.4378 25.0133 31.0401 16 31.0401C14.3811 31.0401 12.8278 30.8263 11.3685 30.425C11.0848 30.3469 10.7831 30.369 10.5139 30.4877L7.33814 31.8897C6.50742 32.2564 5.5697 31.6657 5.54186 30.7578L5.45472 27.9117C5.444 27.561 5.28624 27.2333 5.0249 26.9994C1.91168 24.2153 0 20.1846 0 15.52ZM11.0921 12.6021L6.39206 20.0588C5.94102 20.7744 6.82064 21.5808 7.49446 21.0694L12.543 17.2379C12.8845 16.9787 13.3565 16.9773 13.6994 17.2346L17.4377 20.0382C18.5594 20.8796 20.1603 20.5842 20.908 19.398L25.608 11.9413C26.0589 11.2257 25.1794 10.4193 24.5055 10.9306L19.457 14.7621C19.1154 15.0213 18.6435 15.0227 18.3005 14.7654L14.5624 11.9618C13.4406 11.1205 11.8397 11.4159 11.0921 12.6021Z",
    fill: "url(#paint0_linear_5138_4239)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5138_4239",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#053CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042A8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMess);
export default __webpack_public_path__ + "static/media/mess.8f30d7d3e718d50ab77c9e4cb3f2ad83.svg";
export { ForwardRef as ReactComponent };